import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExternalLink, Minus, Plus, Trash2, X } from 'lucide-react';
import { useStore } from '../../context/StoreContext';
import { toast } from '../../hooks/use-toast';

const R = (n) => `R ${Number(n).toFixed(2)}`;

export default function CartDrawer() {
  const { cart, cartOpen, setCartOpen, updateQty, removeFromCart, findItem, subtotal, checkoutUrl } = useStore();
  const navigate = useNavigate();

  const checkout = () => {
    if (checkoutUrl) {
      window.open(checkoutUrl, '_blank');
      setCartOpen(false);
      return;
    }
    toast({ title: 'Add a Shopify product first', description: 'Items in bag are demo products. Add a product in Shopify Admin and it will route through Shopify checkout.' });
  };

  return (
    <div className={`fixed inset-0 z-50 ${cartOpen ? '' : 'pointer-events-none'}`}>
      <div onClick={() => setCartOpen(false)} className={`absolute inset-0 bg-espresso/50 transition-opacity duration-500 ${cartOpen ? 'opacity-100' : 'opacity-0'}`} />
      <aside className={`absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-ivory text-espresso transition-transform duration-500 ${cartOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between border-b border-stone-warm px-6 py-5">
          <h2 className="font-display text-2xl">Your Bag</h2>
          <button onClick={() => setCartOpen(false)} aria-label="Close cart"><X className="size-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-6">
          {cart.length === 0 && (
            <div className="py-16 text-center">
              <p className="text-espresso/60">Your bag is empty.</p>
              <button onClick={() => { setCartOpen(false); navigate('/shop'); }} className="mt-6 btn btn-dark">Continue shopping</button>
            </div>
          )}
          {cart.map((c) => {
            const it = findItem(c.id); if (!it) return null;
            return (
              <div key={c.id} className="flex gap-4 border-b border-stone-warm py-5">
                <img src={it.image} alt={it.title} loading="lazy" className="size-20 object-cover" />
                <div className="flex-1">
                  <div className="flex justify-between gap-2">
                    <p className="font-display text-lg leading-tight">{it.title}</p>
                    <button onClick={() => removeFromCart(c.id)} aria-label="Remove"><Trash2 className="size-3.5 text-espresso/50" /></button>
                  </div>
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center border border-stone-warm">
                      <button className="p-1.5" onClick={() => updateQty(c.id, c.qty - 1)} aria-label="Decrease"><Minus className="size-3" /></button>
                      <span className="w-6 text-center text-sm">{c.qty}</span>
                      <button className="p-1.5" onClick={() => updateQty(c.id, c.qty + 1)} aria-label="Increase"><Plus className="size-3" /></button>
                    </div>
                    <span className="text-sm">{R(it.price * c.qty)}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {cart.length > 0 && (
          <div className="space-y-4 border-t border-stone-warm px-6 py-6">
            <div className="flex justify-between font-display text-xl"><span>Subtotal</span><span>{R(subtotal)}</span></div>
            <p className="text-xs text-espresso/60">{checkoutUrl ? 'Discount codes and delivery are added at Shopify checkout.' : 'Add products in Shopify Admin to enable real checkout.'}</p>
            <button className="btn btn-primary w-full" onClick={checkout}><ExternalLink className="size-4" />{checkoutUrl ? 'Checkout with Shopify' : 'Checkout (demo)'}</button>
          </div>
        )}
      </aside>
    </div>
  );
}
